__turbopack_context__.v({
  "container_singleColumn": "bvM7ea_container_singleColumn",
  "learnMoreLayout": "bvM7ea_learnMoreLayout",
  "similarTitlesLayout": "bvM7ea_similarTitlesLayout",
});
